<div class="d-flex justify-content-center align-items-center flex-column">
  <h1>Google Account wird verbunden. Bitte warten...</h1>
  <div class="spinner mt-5"></div>
</div>

